/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormEditCreateUpdatePhoneNumberFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/phonenumber/create-update/form-edit-create-update-phonenumber-field-dialog.component';
/* eslint-enable */

/**
 * PhoneNumber field implementation.
 */
export class FormEditPhoneNumberFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(private injector: Injector,
              private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdatePhoneNumberFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdatePhoneNumberFieldDialogComponent)
      .create(this.injector);
  }

}
